import React from "react";
import { FormGroup, Label } from "reactstrap";
import PropTypes from "prop-types";
import ConversionInput from "./ConversionInput";
import { CONVERSION_ERROR } from "./text";

const ConversionError = ({ recoveryData, handleChangeConversionFactor }) => {
  return (
    <div>
      <FormGroup className="mt-1 ">
        <Label for="exampleFile">{`${CONVERSION_ERROR.DESCRIPTION}'${recoveryData.conversion_from_unit_display}' to '${recoveryData.conversion_to_unit_display}'`}</Label>
        <ConversionInput
          handleChangeConversionFactor={handleChangeConversionFactor}
          missing_unit={recoveryData.conversion_from_unit_display}
          normalized_unit={recoveryData.conversion_to_unit_display}
        />
      </FormGroup>
    </div>
  );
};

ConversionError.propTypes = {
  recoveryData: PropTypes.object,
  handleChangeConversionFactor: PropTypes.func,
};

export default ConversionError;
